import { GIT_REPO_ATTACHMENT_ID, GitRepoAttachmentConfigSchema } from '@runloop/reflex-contract';
import { getGitRepoAttachment } from '@reflex/shared';
import type { AgentDraft } from '@/lib/types';
import type { AgentMetaLineProps } from '@/components/agent/agent-meta-line-props';

/**
 * Derive sidebar metadata fields from a draft payload. Reads repo/branch from
 * `attachmentValues['git-repo']` first, then falls back to the `attachments`
 * array and top-level `repoSlug` / `repoBranch` convenience fields.
 */
export function getDraftMeta(draft: AgentDraft): Partial<AgentMetaLineProps> {
  const { payload } = draft;
  const attachmentEntry = payload.attachmentValues?.[GIT_REPO_ATTACHMENT_ID];
  const attachmentConfig = attachmentEntry
    ? GitRepoAttachmentConfigSchema.safeParse(attachmentEntry.config)
    : null;
  const repoFromAttachments = getGitRepoAttachment({ attachments: payload.attachments });

  const repoSlug =
    (attachmentConfig?.success ? attachmentConfig.data.repoSlug : undefined) ??
    repoFromAttachments?.repoSlug ??
    payload.repoSlug;
  const branch =
    (attachmentConfig?.success ? attachmentConfig.data.repoBranch : undefined) ??
    repoFromAttachments?.repoBranch ??
    payload.repoBranch;

  return {
    agentType: payload.agentType,
    model: payload.model,
    repoSlug,
    branch,
  };
}
